import styled from "styled-components";

export const MainSection = styled.section`
  max-width: 1440px;
  margin: 0 auto;
  padding: 140px 20px 40px;
`;

export const Title = styled.h1`
  margin: 0 0 18px 0;
`;

export const Section = styled.section`
  margin-top: 28px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 10px 0;
`;

export const Paragraph = styled.p`
  line-height: 1.6;
  margin: 10px 0;
  overflow-wrap: anywhere;
`;

export const ParagraphTight = styled.p`
  line-height: 1.6;
  margin: 0;
`;

export const ItemBlock = styled.div`
  margin: 10px 0;
  line-height: 1.6;
`;

export const Bullets = styled.ul`
  margin-top: 8px;
  padding-left: 18px;
`;